<template>
  <div class="column-content-tab-bar">
    <ColumnContentTab
      v-for="(tab, tab_k) in contentTabs"
      :key="tab_k"
      :text-label="dateFormat(tab.announce_at)"
      :link="tab.link"
      :activiated="isActiviated(tab)"
      @click="contentTabOnclick(tab,tab_k)"
    />
  </div>
</template>
<script>
export default {
  name: "ColumnContentTabBar",
  props: {
    selectedTabId: {
      type: Number,
      default: 0
    },
    contentTabs: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  methods: {
    isActiviated(tab) {
      return this.selectedTabId === tab.id;
    },
    contentTabOnclick(tab, index) {
      let tabContent = {
        tab: tab,
        index: index
      };
      this.$emit("click", tabContent);
    },
    dateFormat(time) {
      if (!time) return;
      return this.$moment(time)
        .format("YYYY-MM-DD");
    }
  }
};
</script>
<style lang="scss" scoped>
.column-content-tab-bar {
  @include flex;
  flex-direction: column;
  width: 122px;
  border-left: 1px solid var(--blue-50);
  .column-content-tab {
    margin-left: -1px;
  }
}
</style>